module.exports = __webpack_public_path__ + "giving/public/shared/assets/search.svg?637f1145d70cf58ad3d215d7b3c53390";